import { render, staticRenderFns } from "./empytLayout.vue?vue&type=template&id=4499d8b9"
import script from "./empytLayout.vue?vue&type=script&lang=js"
export * from "./empytLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports